<template>
  <div>
    <button
      v-on:click="stokEkstre()"
      style="border: none; background: none; margin-right: 5px"
    >
      <box-icon
        style="float: right"
        name="search-alt-2"
        animation="tada-hover"
        color="#7367F0"
        class="text-body align-middle mr-25"
      ></box-icon>
    </button>
    <StokEkstre ref="ekstre" />
  </div>
</template>
<script>
import "boxicons";
import Store from "../../../../store/store";
import state from "../../../../store/state";

import StokEkstre from "./StokEkstre.vue";

import { BTabs, BTab } from "bootstrap-vue";
export default {
  data() {
    return {
      popupKartDetay: false,
      stokNo: "",
      stokAdi: "",
    };
  },
  components: {
    BTabs,
    BTab,
    StokEkstre,
  },
  methods: {
    stokEkstre() {
      console.log(this.params.data);

      this.$store.commit(
        "account/STOKSTOCKNAME_TUT",
        this.params.data.STOCKNAME
      );
      this.$store.commit("account/STOKID_TUT", this.params.data.STOCKID);
      this.$store.commit("account/STOKSTOCKNO_TUT", this.params.data.STOCKNO);
      this.$refs.ekstre.stokEkstreDetay();
      // this.$store.commit("account/STOCKIDALTER_TUT", this.params.data.STOCKIDALTER);
    },
  },
};
</script>
<style lang="scss">
.con-vs-popup .vs-popup {
  width: 1200px;
}
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}
</style>